export const CONST_API_URL = `${process.env.REACT_APP_API_URL}`
export const CONST_CLIENT_LOGOS = `${process.env.REACT_APP_IMAGES_URL}/logos`
export const CONST_VERBATIM_PATH = `${process.env.REACT_APP_VERBATIM_URL}/`
export const CONST_IMG_URL = process.env.REACT_APP_IMG_URL_prod
export const CONST_CLIENT_LOGOS_EXTENSION = '.png'
export const CONST_CLIENT_IMAGES = 'assets/img-client/'

// APP MIX PASSWORDS
// export const CONST_PASSWORD1_VERBATIM = 'uploadverbatim' // `${process.env.PASSWORD1_VERBATIM}`
// export const CONST_PASSWORD2_VERBATIM = 'testfreak' // `${process.env.PASSWORD2_VERBATIM}`

// USER MANAGEMENT
// export const CONST_PASSWORD_USER_MANAGEMENT = 'testfreak'
// export const CONST_PASSWORD_USER_MANAGEMENT_ACCESS = 'testfreak'
